<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Solicitud de Matriculación </h3>
            <h6 align="right">Costo Matriculacion : {{ c_cost_enrollment }}</h6>
            <h6 align="right">UFV : {{ c_ufv }} al {{ ufv_date }} <button class="btn btn-success" @click="callUfv"> <font-awesome-icon icon="sync-alt" size="lg" /> </button></h6>
            <h5 align="left">P: {{ c_type_propulsion }} A: {{ c_service }}  T: {{ c_trb }} C: {{ c_cal_cut }} </h5>
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link disabled" :class="[is_active_step_one ? 'active':'']" id="nav-init-enrollment" data-toggle="tab" href="#nav-init-enrollment" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_two ? 'active':'']" id="nav-second-enrollment" data-toggle="tab" href="#nav-second-enrollment" role="tab" aria-controls="nav-detail" aria-selected="false">2. Detalle</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_tree ? 'active':'']" id="nav-tirdh-enrollment" data-toggle="tab" href="#nav-tirdh-enrollment" role="tab" aria-controls="nav-property" aria-selected="false">3. Motor</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_fourth ? 'active':'']" id="nav-fourth-enrollment" data-toggle="tab" href="#nav-fourth-enrollment" role="tab" aria-controls="nav-motor" aria-selected="false">4. Propietario</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                
                <div class="tab-pane fade" :class="[is_active_step_one ? 'show active':'']" id="nav-init-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcación</label>                    
                            <input type="text" class="form-control" v-model="name_ship" id="enrollment_boat" placeholder="Nombre Embarcacion" autocomplete="off">
                        </div>
                        
                        <div class="form-group col col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera de la Embarcación</label>
                            <input type="text" class="form-control" v-model="flag" name="flag" disabled placeholder="BOLIVIA" autocomplete="off">
                        </div>

                    </div>
                    <div class="form-row">    

                        <!-- <div class="form-group col col-md-6">
                            <label for="propulsion" class="badge badge-primary">Señal de llamada</label>
                            <input type="text" class="form-control" v-model="call_sign" name="call_sign" placeholder="Señal de llamada" autocomplete="off">
                        </div> -->
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="material_head" class="badge badge-primary">Material del casco</label>
                            <select class="form-control" name="material_head" v-model="material_head">
                                <option v-for="head in material_heads" :value="head.id" :key="head.id">{{ head.detail }}</option>
                            </select>
                        </div>
                        
                        <div class="form-group col col-md-6">
                            <label for="type_navigate" class="badge badge-primary">Tipo Navegación</label>
                            <select class="form-control" name="type_navigate" v-model="type_navigate">
                                <option v-for="navigate in type_navigates" :value="navigate.id" :key="navigate.id">{{ navigate.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo de nave</label>
                            <select class="form-control" name="type_ship" v-model="type_ship">
                                <option v-for="ship in type_ships" :value="ship.id" :key="ship.id">{{ ship.detail }}</option>
                            </select>
                        </div>
                        <div class="form-group col col-md-6">
                            <label for="type_ship" class="badge badge-primary">Tipo de Propulsión</label>
                            <select class="form-control" name="type_ship" v-model="d_type_propulsion">
                                <option v-for="propulsion in d_type_propulsions" :value="propulsion" :key="propulsion.id">{{ propulsion.detail }}</option>
                            </select>
                        </div>                        
                    </div>
                    
                    

                    <button class="btn btn-outline-warning col col-md-4 offset-md-4" @click="fNext"><font-awesome-icon icon="chevron-circle-right" size="lg" /></button>
                </div>
                <!-- end first tab traffic -->

                <div class="tab-pane fade" :class="[is_active_step_two ? 'show active':'']" id="nav-second-enrollment" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="number" name="trb" class="form-control" placeholder="TRB" v-model="trb" autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="trn" class="badge badge-primary">TRN</label>
                            <input type="number" name="trn" class="form-control" placeholder="TRN" v-model="trn" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md-3">
                            <label for="eslora" class="badge badge-primary">Eslora</label>
                            <input type="number" class="form-control" v-model="eslora" name="eslora" placeholder="Eslora" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="manga" class="badge badge-primary">Manga</label>
                            <input type="number" class="form-control" v-model="manga" name="manga" placeholder="Manga" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="puntal" class="badge badge-primary">Puntal</label>
                            <input type="number" class="form-control" v-model="puntal" name="puntal" placeholder="Puntal" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-3">
                            <label for="eslora" class="badge badge-primary">Calado</label>
                            <input type="number" class="form-control" v-model="calado" name="calado" placeholder="Calado" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col col-md-3">
                            <label for="year_construction" class="badge badge-primary">Año de construccion</label>
                            <input type="number" class="form-control" v-model="year_construction" name="flag" placeholder="Año" autocomplete="off">
                        </div>

                        <div class="form-group col col-md-6">
                            <label for="site_contruction" class="badge badge-primary">Lugar construccion</label>
                            <input type="text" class="form-control" v-model="site_construction" name="call_sign" placeholder="Lugar de construccion" autocomplete="off">
                        </div>

                        <div class="form-group col col-md-3">
                            <label for="cost_construction" class="badge badge-primary">Costo de construccion Bs.</label>
                            <input type="number" class="form-control" v-model="cost_construction" name="flag" placeholder="Costo" autocomplete="off">
                        </div>
                    </div>  

                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="type_ship" class="badge badge-primary">Destino Actividad</label>
                            <select class="form-control" name="type_ship" v-model="d_type_activity_ship" @change="callService">
                                <option v-for="activity in d_types_activity_ship" :value="activity.id" :key="activity.id">{{ activity.detail }}</option>
                            </select>
                        </div>

                        <transition name="fade" mode="out-in">
                        <div class="form-group col col-md-6" v-if="type_services.length > 0">
                            <label for="type_service" class="badge badge-primary">Tipo de Servicio</label>
                            <select class="form-control" name="type_service" v-model="type_service">
                                <option v-for="service in type_services" :value="service" :key="service.id">{{ service.detail }}</option>
                            </select>
                        </div>
                        </transition>

                    </div>

                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end second tab -->

                <div class="tab-pane fade" :class="[is_active_step_tree ? 'show active':'']" id="nav-tirdh-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <transition name="fade" mode="out-in">
                        <div class="form-row" v-if="cQuestionEngine">
                            <span class="col-12">¿Desea agregar caracteristicas de motor a la nave? <br>Caso contrario omita este mensaje y pase al siguiente paso  </span>                        
                            <button class="btn btn-outline-success btn-sm col-6 col-md-2 offset-md-4" value="si" @click="mAddEngine">AGREGAR</button>
                            <!-- <button class="btn btn-outline-danger btn-sm col-6 col-md-2" value="no" @click="mAddEngine">NO</button> -->
                            
                        </div>
                        
                    </transition>

                    <transition name="fade" mode="out-in">
                    <div v-if="engine.exists">
                        <div class="form-row">
                            <button type="button" class="btn btn-outline-warning col-12 col-md-1 offset-md-10" @click="mAddEngine" value="no"><font-awesome-icon icon="redo-alt" /></button>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="brand_engine" class="badge badge-primary">Marca Motor</label>
                                <input type="text" class="form-control" v-model="engine.trademark" name="flag" placeholder="Marca Motor" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="model_engine" class="badge badge-primary">Modelo Motor</label>
                                <input type="text" class="form-control" v-model="engine.model" name="model_engine" placeholder="Modelo Motor" autocomplete="off">
                            </div>                        
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="rpm_engine" class="badge badge-primary">HP por RPM</label>
                                <input type="number" class="form-control" v-model="engine.rpm" name="flag" placeholder="Hp por RPM" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="serie_engine" class="badge badge-primary">Serie</label>
                                <input type="text" class="form-control" v-model="engine.serie" name="model_engine" placeholder="Serie Motor" autocomplete="off">
                            </div>                    
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="combustible_construction" class="badge badge-primary">Combustible</label>
                                <select class="form-control" name="combustible_construction" v-model="engine.gasoline">
                                    <option v-for="gas in type_gasolines" :value="gas.id" :key="gas.id">{{ gas.detail }}</option>
                                </select>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_autonomia" class="badge badge-primary">Autonomia</label>
                                <input type="text" class="form-control" v-model="engine.autonomia" name="model_engine" placeholder="Autonomia Motor" autocomplete="off">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="engine_velocity" class="badge badge-primary">Velocidad Maxima KPH</label>
                                <input type="number" class="form-control" v-model="engine.velocity_max" name="engine_velocity" placeholder="Velocidad Maxima" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    </transition>
                    <br>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">
                        <font-awesome-icon icon="chevron-circle-right" size="lg" />
                    </button>
                </div>
                <!-- end trirdh tab -->
                <div class="tab-pane fade" :class="[is_active_step_fourth ? 'show active':'']" id="nav-fourth-enrollment" role="tabpanel" aria-labelledby="nav-home-tab">
                    <br>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="type_identification" class="badge badge-primary">Tipo Identificacion</label>
                            <select class="form-control" name="type_ship" v-model="owner.type_identification" :disabled="d_owner_disabled" @change="mChangeOwnerIdentification">
                                <option v-for="identification in types_identification" :value="identification.id" :key="identification.id">{{ identification.detail }}</option>
                            </select>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                            <input type="text" class="form-control" v-model="owner.number_identification" name="number_identification" placeholder="Numero de Identificacion" :disabled="d_owner_disabled" autocomplete="off">
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="site_expedition" class="badge badge-primary">Lugar Emision </label>
                            <select class="form-control" name="site_expedition" v-model="owner.site_expedition" :disabled="d_owner_disabled">
                                <option v-for="city in citys" :value="city.id" :key="city.id">{{ city.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="owner_name" class="badge badge-primary">Nombre Propietario</label>
                            <input type="text" class="form-control" v-model="owner.name" name="owner_name" placeholder="Nombre Propietario" autocomplete="off" :disabled="d_owner_disabled">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_direction" class="badge badge-primary">Direccion </label>
                            <input type="text" class="form-control" v-model="owner.direction" name="owner_direction" placeholder="Direccion" autocomplete="off" :disabled="d_owner_disabled">
                        </div>
                    </div>

                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_celular" class="badge badge-primary">Celular </label>
                            <input type="number" class="form-control" v-model="owner.mobile" name="owner_celular" placeholder="Celular" autocomplete="off" :disabled="d_owner_disabled">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="phone_static" class="badge badge-primary">Telefono Fijo </label>
                            <input type="number" class="form-control" v-model="owner.phone" name="phone_static" placeholder="Telefono Fijo" autocomplete="off" :disabled="d_owner_disabled">
                        </div>
                    </div>
                    
                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_partner" class="badge badge-primary">Representante Legal </label>
                            <input type="text" class="form-control" v-model="owner.partner" name="owner_partner" placeholder="Representante Legal" autocomplete="off" :disabled="d_disabled_partner">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_nationality" class="badge badge-primary">Nacionalidad </label>
                            <select class="form-control" name="site_expedition" v-model="owner.nationality" :disabled="d_owner_disabled">
                                <option v-for="country in countrys" :value="country.id" :key="country.id">{{ country.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row" v-if="autImport==='S' && c_cost_enrollment > 0 " >
                        <button class="btn btn-outline-danger col-md-1 offset-md-5" @click="mEditImport('R')"><font-awesome-icon icon="minus-circle" /></button>           
                        <button class="btn btn-outline-danger col-md-1" @click="mEditImport('I')"><font-awesome-icon icon="plus" /></button>
                    </div>
                    <br>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">
                        <font-awesome-icon icon="chevron-circle-left" size="lg" />
                    </button>
                    <button class="btn btn-outline-primary col col-md-4" @click="mValidateSend">Solicitar <font-awesome-icon icon="save" size="lg" /></button>    
                </div>
            </div>
            
        </div>
        <modal-loading :id-modal="modal_progress" :title="'Solicitando'" :status-send="send_dispatch" ></modal-loading>
        <modal-report :id-modal-report="modal_report" :title="modal_rep_title" :content="modal_rep_content" :url-r="url_report" :id-report="id_reporte" ></modal-report>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');
import modalLoading from '../modal/modalLoading';
import modalReport from '../modal/modalReport';


export default {
    name:'enrollment-pasavant',
    data(){
        return{
            autImport:'N',
            maxResult:50,
            searchOwner:'Busqueda Nombre',
            query_owner:null,
            owners_enrollment:[],
            is_active_step_one:true,
            is_active_step_two:false,
            is_active_step_tree:false,
            is_active_step_fourth:false,
            name_ship:null,
            omi:null,
            flag:'BOLIVIA',
            call_sign:null,
            material_head:null,
            type_ship:null,
            material_heads:[],
            type_ships:[],
            eslora:null,
            manga:null,
            puntal:null,
            calado:null,
            year_construction:null,
            site_construction:null,
            cost_construction:null,
            type_service:{
                id:null,
                detail:null,
                factor:null
            },
            type_services:[],
            type_navigate:null,
            type_navigates:[],
            d_type_propulsions:[],
            d_type_propulsion:{
                id:null,
                detail:null,
                factor:null
            },
            d_type_activity_ship:null,
            d_types_activity_ship:[],
            type_gasolines:[],
            engine:{
                exists:false,
                trademark:null,
                model:null,
                rpm:null,
                serie:null,
                gasoline:null,
                autonomia:null,
                velocity_max:null
            },
            owner:{
                id:0,
                type_identification:null,
                number_identification:null,
                site_expedition:null,
                name:null,
                direction:null,
                mobile:null,
                phone:null,
                partner:null,
                nationality:null
            },
            d_owner_disabled:false,
            types_identification:[],
            citys:[],
            countrys:[],
              trn:null,
            trb:null,
            modal_progress:'sendEnrollment',
            modal_report:'requestEnrollment',
            modal_rep_title:'Solicitud de Matriculación',
            modal_rep_content:'',
            url_report:'pdfRequestEnrollment',
            send_dispatch:true,
            id_reporte:0,
            d_question_engine:true,
            d_disabled_partner:false,
            date_ufv:null,
            ufv_date:null
        }
    },
    mounted(){
        this.callHeads(),
        this.callTypeShip(),
        this.callTypeNavigate(),
        this.mCallPropulsion(),
        this.mCallActivitiesShip(),
        this.mCallGasolines(),
        this.mCallIdentifications(),
        this.mCallCitys(),
        this.mCallCountrys(),
        this.callUfv(),
        this.mChargeStore()
    },
    methods:{
        mChargeStore(){
            // aqui cargamos el storage a las variables que ya tienen los formularios
            // console.log('aqui llegamos a la carga inicial del storage a las variables');
            // console.log(this.c_ship_pasavant);
            // console.log(this.c_engine_pasavant);
            // console.log(this.c_owner_pasavant);

            this.name_ship=this.c_ship_pasavant.name_ship;
            this.omi=0;
            this.flag=this.c_ship_pasavant.flag;
            this.call_sign=0;
            this.material_head=this.c_ship_pasavant.material_head;
            this.type_navigate=this.c_ship_pasavant.type_navigate;
            this.type_ship=this.c_ship_pasavant.type_ship
            this.d_type_propulsion=this.c_ship_pasavant.d_type_propulsion;
            this.trb=this.c_ship_pasavant.trb;
            this.trn=this.c_ship_pasavant.trn;
            this.eslora=this.c_ship_pasavant.eslora;
            this.manga=this.c_ship_pasavant.manga;
            this.puntal=this.c_ship_pasavant.puntal;
            this.calado=this.c_ship_pasavant.calado;
            this.year_construction=this.c_ship_pasavant.year_construction;
            this.site_construction=this.c_ship_pasavant.site_construction;
            this.cost_construction=this.c_ship_pasavant.cost_construction;
            this.type_service=this.c_ship_pasavant.type_service;
            // this.c_cost_enrollment=0;

            if(this.c_engine_pasavant.id_engine > 0){
                this.engine.id_engine=this.c_engine_pasavant.id_engine;
                this.engine.exists=this.c_engine_pasavant.exists;
                this.engine.trademark=this.c_engine_pasavant.trademark;
                this.engine.model=this.c_engine_pasavant.model;
                this.engine.rpm=this.c_engine_pasavant.rpm;
                this.engine.serie=this.c_engine_pasavant.serie;
                this.engine.gasoline=this.c_engine_pasavant.gasoline;
                this.engine.autonomia=null
                this.engine.velocity_max=this.c_engine_pasavant.velocity_max;
            }
                

            if(this.c_owner_pasavant.id_owner > 0){
                    this.owner.id_owner=this.c_owner_pasavant.id_owner;
                    this.owner.type_identification=this.c_owner_pasavant.type_identification;
                    this.owner.number_identification=this.c_owner_pasavant.number_identification;
                    this.owner.site_expedition=this.c_owner_pasavant.site_expedition;
                    this.owner.name=this.c_owner_pasavant.name;
                    this.owner.direction=this.c_owner_pasavant.direction;
                    this.owner.mobile=this.c_owner_pasavant.mobile;
                    this.owner.phone=this.c_owner_pasavant.phone;
                    this.owner.partner=this.c_owner_pasavant.partner;
                    this.owner.nationality=this.c_owner_pasavant.nationality;
            }
        },
        mEditImport(t){
            let aux_imp=0;
            switch(t){
                case 'R':
                    // console.log(`restamos el importe ${this.type_service.factor}`);
                    aux_imp=parseFloat(this.type_service.factor)-0.2;
                    if(aux_imp>0){
                        this.type_service.factor=aux_imp;
                        // this.calculateForm();
                    }
                    break;
                
                case 'I':
                    // console.log(`incrementamos el importe ${this.type_service.factor}`);
                    aux_imp=parseFloat(this.type_service.factor)+0.2;
                    if(aux_imp>0){
                        this.type_service.factor=aux_imp;
                        // this.calculateForm();
                    }
                    break;
            }
        },
        mSelectedOwner(data){
            // console.log(data);
            this.owner.id=data.id_propietario;
            this.owner.type_identification=data.tipo_identificacion;
            this.owner.number_identification=data.dato_identificacion;
            this.owner.site_expedition=data.id_expedido;
            this.owner.name=data.nombre_propietario;
            this.owner.direction=data.domicilio;
            this.owner.mobile=data.celular;
            this.owner.phone=data.telefono_fijo;
            this.owner.partner=data.representante_legal;
            this.owner.nationality=data.id_nacionalidad;
            this.d_owner_disabled=true;
            this.d_disabled_partner=true;

        },
        mResetSelectOwner(){
            this.owner.id=0;
            this.owner.type_identification=null;
            this.owner.number_identification=null;
            this.owner.site_expedition=null;
            this.owner.name=null;
            this.owner.direction=null;
            this.owner.mobile=null;
            this.owner.phone=null;
            this.owner.partner=null;
            this.owner.nationality=null;
            this.d_owner_disabled=false;
            this.d_disabled_partner=false;
        },
        mAddEngine(event){
            switch(event.target.value){
                case 'no':
                    this.d_question_engine=true;
                    this.engine.exists=false;                    
                break;

                case 'si':
                    this.d_question_engine=false;
                    this.engine.exists=true;
                break;
            }
        },
        mProgressModal(){
            $('#'+this.modal_progress).modal('show');
        },
        mCloseProgressModal(){
            $('#'+this.modal_progress).modal('hide');
        },
        mModalReportShow(){
            $('#'+this.modal_report).modal('show');
        },
        mCallCountrys(){
            // axios.get(`globals/country`)
            axios.get(`globals/country?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.countrys=res.data
            })
        },
        mCallCitys(){
            // axios.get(`globals/citys`)
            axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.citys=res.data
            })
        },
        mCallIdentifications(){
            // axios.get(`globals/ident`)
            axios.get(`globals/ident?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.types_identification=res.data
            })
        },
        mCallGasolines(){
            // axios.get(`globals/gasoline`)
            axios.get(`globals/gasoline?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_gasolines=res.data
            })
        },
        mCallPropulsion(){
            // axios.get(`submenus/4`)
            axios.get(`submenus/4?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.d_type_propulsions=res.data
            })
        },
        callHeads(){
            this.autImport=Vue.auth.getAutImp();
            // axios.get(`globals/materialhead`)
            axios.get(`globals/materialhead?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.material_heads=res.data
            })
        },
        callTypeShip(){
            // axios.get(`globals/ships`)
            axios.get(`globals/ships?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                
                this.type_ships=res.data
            })
        },
        mCallActivitiesShip(){
            // axios.get(`ships/servicionave`)
            axios.get(`ships/servicionave?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                this.d_types_activity_ship=res.data;
            })
        },
        callService(){
            this.type_services=[];
            // axios.get(`submenus/${this.d_type_activity_ship}`)
            axios.get(`submenus/${this.d_type_activity_ship}?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_services=res.data
            })
        },
        callTypeNavigate(){
            // axios.get(`globals/navigates`)
            axios.get(`globals/navigates?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.type_navigates=res.data
            })
        },
        mSendEnrollment(){
            
            let ship_local={
                id_ship:this.c_ship_pasavant.id_ship,
                name:this.name_ship,
                n_omi:this.omi,
                flag:this.flag,
                call_sign:this.call_sign,
                material_casco:this.material_head,
                tipo_navegacion:this.type_navigate,
                tipo_nave:this.type_ship,
                tipo_propulsion:parseInt(this.d_type_propulsion.id),
                trb:parseFloat(this.trb),
                trn:parseFloat(this.trn),
                eslora:parseFloat(this.eslora),
                manga:parseFloat(this.manga),
                puntal:parseFloat(this.puntal),
                calado:parseFloat(this.calado),
                anio_contruction:parseInt(this.year_construction),
                lugar_construction:this.site_construction,
                costo_construction:this.cost_construction ? parseFloat(this.cost_construction):0,
                destino_servicio:this.type_service.id,
                importe:this.c_cost_enrollment,
                ufv:this.c_ufv
            }

            let motor={
                id_engine:this.engine.id_engine,
                existe:this.engine.exists,
                marca:this.engine.trademark,
                modelo:this.engine.model,
                rpm:this.engine.rpm,
                serie:this.engine.serie,
                combustible:parseInt(this.engine.gasoline),
                autonomia:this.engine.autonomia,
                velocidad_maxima:parseFloat(this.engine.velocity_max)
            }

            let propietario={
                id_propietario:this.owner.id,
                t_idenficacion:parseInt(this.owner.type_identification),
                n_identificacion:this.owner.number_identification,
                expedido:parseInt(this.owner.site_expedition),
                nombre_propietario:this.owner.name,
                direccion:this.owner.direction,
                celular:parseInt(this.owner.mobile),
                telefono:parseInt(this.owner.phone),
                representante:this.owner.partner,
                nacionalidad:parseInt(this.owner.nationality)
            }
            let param={
                    boat:JSON.stringify(ship_local),
                    motor:JSON.stringify(motor),
                    owner_ship:JSON.stringify(propietario)
                }
            //# FIXME: verificar el rechazo si es que la serie del motor se encuentra registrado y se intenta registrar el mismo, se debe rechazar e indicar que la serie del motor ya esta registrada 
            
            // console.log(ship_local);
            let message = {
                title: `Solicitud de Matriculacion de Nave`,
                body: `¿Desea registrar la solicitud para la Nave o Artefacto Naval, <b>${ship_local.name.toUpperCase()}</b> ?`
            };

            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then((msg) =>{
                if(msg){
                    this.mProgressModal();
                    // axios.post(`insertRequestEnrollment`,
                    axios.post(`insertRequestEnrollmentPasavant?api_token=${Vue.auth.getToken()}`,
                                qs.stringify(param))
                    .then(res=>{                        
                        setTimeout(()=>{
                            this.mCloseProgressModal();
                            this.modal_rep_content=res.data[0].respuesta;
                            this.id_reporte=res.data[1].id_rep;
                            if(this.id_reporte !== 0){
                                toastr.success('Exito en el registro de la solicitud', 'Exito');
                                this.mModalReportShow();
                                this.mResetSelectOwner();
                                this.mResetForm();
                            }else{
                                toastr.error('Ha ocurrido un error', 'Error');
                                this.mModalReportShow();
                            }                            
                        }, 2000);
                        
                    }).catch(error => {
                        setTimeout(()=>{
                            this.mCloseProgressModal();
                            toastr.error('Verifique la serie o la documento del propietario','Error');
                        }, 3000);
                        console.log(error)
                    })
                    }else{
                        console.log('se ha rechazado la baja del personal')
                    }
                })
            

        },
        mValidateSend(){
            let aux_validate=true;

            if(!this.name_ship && aux_validate){
                toastr.error('Verifique el nombre de la nave','Nombre');
                aux_validate=!aux_validate;
            }
            if(!this.material_head && aux_validate){
                toastr.error('Verifique el material del casco de la nave','Material Casco');
                aux_validate=!aux_validate;
            }
            if(!this.type_navigate && aux_validate){
                toastr.error('Verifique el tipo de Navegacion','Tipo Navegacion');
                aux_validate=!aux_validate;
            }
            if(!this.type_ship && aux_validate){
                toastr.error('Verifique el tipo de Nave','Tipo Nave');
                aux_validate=!aux_validate;
            }
            if(!this.d_type_propulsion.id && aux_validate){
                toastr.error('Verifique el tipo de Propulsion','Propulsion');
                aux_validate=!aux_validate;
            }
            if(!this.trb && aux_validate){
                toastr.error('Verifique el TRB','TRB');
                aux_validate=!aux_validate;
            }
            if( parseFloat(this.trb) <= parseFloat(this.trn) ){
                toastr.error('El TRN debe ser menor al TRB','TRB');
                aux_validate=!aux_validate;
            }
            if(!this.type_service.id && aux_validate){
                toastr.error('Verifique el tipo de servicio de la Nave','Tipo Servicio');
                aux_validate=!aux_validate;
            }
            if(!this.owner.nationality && aux_validate){                
                toastr.error('Indique la Nacionalidad del Titular','Nacionalidad');
                aux_validate=!aux_validate;
            }
            if(!this.owner.type_identification && aux_validate){
                toastr.error('seleccione un tipo de identificacion','Identificacion');
                aux_validate=!aux_validate;
            }
            if(!this.owner.number_identification && aux_validate){
                toastr.error('Indique un numero de identificacion','Numero Indenficacion');
                aux_validate=!aux_validate;
            }
            if(!this.owner.site_expedition && aux_validate){
                toastr.error('Seleccione el departamento de Emision','Emision de Cedula');
                aux_validate=!aux_validate;
            }
            if(!this.owner.name && aux_validate){
                toastr.error('Indique el Nombre del Propietario','Nombre Propietario');
                aux_validate=!aux_validate;
            }
            if(aux_validate){
                this.mSendEnrollment();
            }
            
        },
        mResetForm(){
            this.name_ship=null;
            this.omi=null;
            this.flag='BOLIVIA';
            this.call_sign=null;
            this.material_head=null;
            this.type_ship=null;
            this.material_heads=[];
            this.type_ships=[];
            this.eslora=null;
            this.manga=null;
            this.puntal=null;
            this.calado=null;
            this.year_construction=null;
            this.site_construction=null;
            this.cost_construction=null;
            this.d_type_activity_ship=null;
            this.d_types_activity_ship=null;
            this.trn=null;
            this.trb=null;
        },
        mChangeOwnerIdentification(){
            
            switch(this.owner.type_identification){
                case 17:
                // cedula identidad
                    this.d_disabled_partner=true;
                break;

                case 18:
                // nit
                    this.d_disabled_partner=false;
                break;
            }
        },
        callUfv(){
            // axios.get('ufv?api_token='+Vue.auth.getToken())
            // axios.get(`ufv`)
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                // console.log(res.data[0])
                // this.ufv=res.data[0].value;
                this.ufv_date=res.data[0].date;
                this.$store.dispatch('addUFV', res.data[0].value);
                // this.();
            })
        },
        fNext(){
            switch(true){
                case this.is_active_step_one:
                    this.is_active_step_one=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_tree=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_fourth=true;
                break;
            }
        },
        fBack(){            
            switch(true){
                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_one=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_fourth:
                    this.is_active_step_fourth=false;
                    this.is_active_step_tree=true;
                break;
            }
        }
    },
    computed:{
        c_ufv(){
            return this.$store.getters.getUFV;
        },
        c_type_propulsion:function(){
            return this.d_type_propulsion.factor;
            // return this.c_ship_pasavant.d_type_propulsion.factor;
        },
        c_trb:function(){
            return this.trb;
        },
        c_service:function(){
            return this.type_service.factor;
        },
        c_cost_enrollment(){
            // console.log(this.c_ship_pasavant);
            // console.log(` valores ${this.c_ufv}, ${ this.c_type_propulsion }, ${ this.c_service }, ${ this.trb}, ${this.c_cal_cut}`)
            let cost_enrollment = 3*this.c_ufv*(5+this.c_type_propulsion*this.c_service*this.trb*this.c_cal_cut);
            // let cost_enrollment = 3*this.c_type_propulsion;
            
            let aux_number=cost_enrollment.toFixed(2);
            
            let number_enter=Math.trunc(aux_number);
            let number_decimal=Number((aux_number-number_enter).toFixed(2));

            

            if(number_decimal===0.50){
                cost_enrollment=aux_number;

            }else if(number_decimal>0.50){
                cost_enrollment=number_enter+1;
                
            }else{                
                cost_enrollment=number_enter;
            }

            return cost_enrollment;
        },
        c_cal_cut(){
            let fact_a=0.1; 
            let fact_b=2;
            let fact_c=1.8;
            let cut=fact_c/(1+fact_a*Math.pow(this.c_trb, (1/fact_b) ))/2.3;
            return cut;
        },
        cQuestionEngine(){
            return this.d_question_engine;
        },
        c_ship_pasavant(){
            return this.$store.getters['sPasavantOf/getShipPasavant'];
        },
        c_owner_pasavant(){
            return this.$store.getters['sPasavantOf/getOwnerPasavant'];
        },
        c_engine_pasavant(){
            return this.$store.getters['sPasavantOf/getShipPasavant'];
        }
    },
    watch:{
        query_owner(newOwner) {
            axios.get(`searchOwner/${newOwner}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    this.owners_enrollment = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-report':modalReport
    }
}
</script>



// WEBPACK FOOTER //
// src/components/matriculacion/MatriculacionPasavant.vue